
<div class="row">
    <div class="card">
      <div class="card-body bg-white">
    <form  (ngSubmit)="onSubmit(passportCheck.value,'form')" [formGroup]="passportCheck">
  <div class="card pt-0 mb-5">
      <div class="card-header">
          <h4>Passport Check</h4>
        </div>
      <div class="card-body">
     <div class="row mb-2">
      <div class="col-lg-6 col-md-6">
          <label class="d-flex align-items-center fs-6 fw-semibold">
              <span class="">Front Page</span>
          </label> 
          <input type="file" class="form-control form-control-sm" formControlName="frontupload"  accept="image/*"  [style.color]="true ? 'limegreen' : ''" (change)="onFileSelectedFront($event)" />

          <div *ngIf="!filedisFront" class="text-danger mt-1">
            Please Upload File.
           </div>
           <!-- <div *ngIf="docerrorisFront" class="text-danger mt-1">
           {{errormsg}}
           </div> -->
        </div>
      <div class="col-lg-6 col-md-6">
          <label class="d-flex align-items-center fs-6 fw-semibold">
              <span class="">Back Page</span>
          </label>
          <input type="file" class="form-control form-control-sm" formControlName="backupload"  accept="image/*"  [style.color]="true ? 'limegreen' : ''" (change)="onFileSelectedBack($event)" />
          <!-- <div *ngIf="!filedisBack" class="text-danger mt-1">
            Please Upload File.
           </div> -->
              </div>
     </div>
     
     <div class="row">
      <div class="col-sm-2">
          <br>
          <div class="mb-3">
          <button class="btn  btn-primary"
                type="submit" value="Submit">Upload</button>
        </div>
        </div>
     </div>
      </div>
      </div>
    </form>
  
    <div class="card pt-0 mb-5">
      <div class="row" style="min-height: 300px">
          <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine">         
            <ag-grid-angular
            style="width: 100%; height: 350px;"
            class="ag-theme-alpine"
            [columnDefs]="columnDefs"
            [defaultColDef]="defaultColDef"
            [suppressRowClickSelection]="true"
            [groupSelectsChildren]="true"
            [rowSelection]="'multiple'"
            [columnDefs]="tableSelectedColumn"
            [pagination]="true"
            (rowClicked)="OnRowClicked($event)"
            [paginationPageSize]=10
            [rowData]="rowData"
          ></ag-grid-angular>         
          </div>
        </div>      
  </div>
  </div>
  </div>
  </div>
  <app-modal #modalbloked [modalConfig]="modalConfigBlocked">
    <!-- {{aa | json}}   -->
    <!-- {{aa[0]?.action}} -->
    <div class="row">
        <div class="col-sm-6 col-md-6 float-left">
            <label class="form-label">File Number</label>
        </div>
        <div class="col-sm-6 col-md-6 float-right">
            <label class="form-label">{{SingleRow?.fileNumber||"NA"}}</label>
        </div>

    </div>
    <div class="row">
        <div class="col-sm-6 col-md-6 float-left">
            <label class="form-label">Name</label>
        </div>
        <div class="col-sm-6 col-md-6 float-right">
            <label class="form-label">{{SingleRow?.name||"NA"}}</label>
        </div>

    </div>
    <div class="row">
        <div class="col-sm-6 col-md-6 float-left">
            <label class="form-label">D.O.B</label>
        </div>
        <div class="col-sm-6 col-md-6 float-right">
            <label class="form-label">{{SingleRow?.dob||"NA"}}</label>
        </div>

    </div>
    <div class="row">
        <div class="col-sm-6 col-md-6 float-left">
            <label class="form-label">Passport Number</label>
        </div>
        <div class="col-sm-6 col-md-6 float-right">
            <label class="form-label">{{SingleRow?.passportNumber||"NA"}}</label>
        </div>

    </div>
    <div class="row">
        <div class="col-sm-6 col-md-6 float-left">
            <label class="form-label">Date of Expiry</label>
        </div>
        <div class="col-sm-6 col-md-6 float-right">
            <label class="form-label">{{SingleRow?.dateOfExpiry||"NA"}}</label>
        </div>

    </div>




    <div class="row">
      <div class="col-sm-6 col-md-6 float-left">
          <label class="form-label">Date of Issue</label>
      </div>
      <div class="col-sm-6 col-md-6 float-right">
          <label class="form-label">{{SingleRow?.dateOFIssue||"NA"}}</label>
      </div>

  </div>
  <div class="row">
      <div class="col-sm-6 col-md-6 float-left">
          <label class="form-label">Place of Birth</label>
      </div>
      <div class="col-sm-6 col-md-6 float-right">
          <label class="form-label">{{SingleRow?.placeOFBirth||"NA"}}</label>
      </div>

  </div>
  <div class="row">
      <div class="col-sm-6 col-md-6 float-left">
          <label class="form-label">Address</label>
      </div>
      <div class="col-sm-6 col-md-6 float-right">
          <label class="form-label">{{SingleRow?.address||"NA"}}</label>
      </div>

  </div>
  <div class="row">
      <div class="col-sm-6 col-md-6 float-left">
          <label class="form-label">District</label>
      </div>
      <div class="col-sm-6 col-md-6 float-right">
          <label class="form-label">{{SingleRow?.district||"NA"}}</label>
      </div>

  </div>


  <div class="row">
    <div class="col-sm-6 col-md-6 float-left">
        <label class="form-label">Father's Name</label>
    </div>
    <div class="col-sm-6 col-md-6 float-right">
        <label class="form-label">{{SingleRow?.fathersName||"NA"}}</label>
    </div>

</div>
<div class="row">
    <div class="col-sm-6 col-md-6 float-left">
        <label class="form-label">First Name</label>
    </div>
    <div class="col-sm-6 col-md-6 float-right">
        <label class="form-label">{{SingleRow?.firstName||"NA"}}</label>
    </div>

</div>
<div class="row">
    <div class="col-sm-6 col-md-6 float-left">
        <label class="form-label">Gender</label>
    </div>
    <div class="col-sm-6 col-md-6 float-right">
        <label class="form-label">{{SingleRow?.gender||"NA"}}</label>
    </div>

</div>
<div class="row">
    <div class="col-sm-6 col-md-6 float-left">
        <label class="form-label">Is scanned</label>
    </div>
    <div class="col-sm-6 col-md-6 float-right">
        <label class="form-label">{{SingleRow?.isSacnned||"NA"}}</label>
    </div>

</div>



<div class="row">
  <div class="col-sm-6 col-md-6 float-left">
      <label class="form-label">Last Name</label>
  </div>
  <div class="col-sm-6 col-md-6 float-right">
      <label class="form-label">{{SingleRow?.lastName||"NA"}}</label>
  </div>

</div>
<div class="row">
  <div class="col-sm-6 col-md-6 float-left">
      <label class="form-label">Mothers Name</label>
  </div>
  <div class="col-sm-6 col-md-6 float-right">
      <label class="form-label">{{SingleRow?.motherName||"NA"}}</label>
  </div>

</div>
<div class="row">
  <div class="col-sm-6 col-md-6 float-left">
      <label class="form-label">Nationality</label>
  </div>
  <div class="col-sm-6 col-md-6 float-right">
      <label class="form-label">{{SingleRow?.nationality||"NA"}}</label>
  </div>

</div>




<div class="row">
  <div class="col-sm-6 col-md-6 float-left">
      <label class="form-label">Pincode</label>
  </div>
  <div class="col-sm-6 col-md-6 float-right">
      <label class="form-label">{{SingleRow?.pincode||"NA"}}</label>
  </div>

</div>
<div class="row">
  <div class="col-sm-6 col-md-6 float-left">
      <label class="form-label">Place of issue</label>
  </div>
  <div class="col-sm-6 col-md-6 float-right">
      <label class="form-label">{{SingleRow?.palceOfIssue||"NA"}}</label>
  </div>

</div>
<div class="row">
  <div class="col-sm-6 col-md-6 float-left">
      <label class="form-label">State</label>
  </div>
  <div class="col-sm-6 col-md-6 float-right">
      <label class="form-label">{{SingleRow?.state||"NA"}}</label>
  </div>

</div>
    
</app-modal>